<template>
  <div id="navigation-drawer-view">
    <v-container fluid>
      <v-layout row justify-center>
        <v-flex xs8>
          <v-card class="ma-3">
            <v-card-title primary-title>
              <div class="headline">Ayuda</div>
            </v-card-title>
            <v-card-text>
              <v-layout row justify-center>
                <v-flex xs8>
                  <v-autocomplete
                    label="Características"
                    prepend-icon="help"
                    v-model="selectedFeature"
                    :items="features"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <event-template-faq
            v-if="selectedFeature === 'Detalles del Evento'"
            :selectedFeature="selectedFeature"
          ></event-template-faq>
          <geofences-faq
            v-if="selectedFeature === 'Geocercas'"
            :selectedFeature="selectedFeature"
          ></geofences-faq>
          <guests-faq
            v-if="selectedFeature === 'Invitados'"
            :selectedFeature="selectedFeature"
          ></guests-faq>
          <places-faq
            v-if="selectedFeature === 'Lugares'"
            :selectedFeature="selectedFeature"
          ></places-faq>
          <reports-faq
            v-if="selectedFeature === 'Reportes'"
            :selectedFeature="selectedFeature"
          ></reports-faq>
          <routes-faq
            v-if="selectedFeature === 'Rutas'"
            :selectedFeature="selectedFeature"
          ></routes-faq>
          <tracking-faq
            v-if="selectedFeature === 'Seguimiento'"
            :selectedFeature="selectedFeature"
          ></tracking-faq>
          <travels-faq
            v-if="selectedFeature === 'Recorridos'"
            :selectedFeature="selectedFeature"
          ></travels-faq>
          <vehicle-template-faq
            v-if="selectedFeature === 'Detalles del Vehículo'"
            :selectedFeature="selectedFeature"
          ></vehicle-template-faq>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import EventTemplateFAQ from '@/components/FAQ/EventTemplate'
import GeofencesFAQ from '@/components/FAQ/Geofences'
import GuestsFAQ from '@/components/FAQ/Guests'
import PlacesFAQ from '@/components/FAQ/Places'
import ReportsFAQ from '@/components/FAQ/Reports'
import RoutesFAQ from '@/components/FAQ/Routes'
import TrackingFAQ from '@/components/FAQ/Tracking'
import TravelsFAQ from '@/components/FAQ/Travels'
import VehicleTemplateFAQ from '@/components/FAQ/VehicleTemplate'

export default {
  name: 'help',
  data: function () {
    return {
      selectedFeature: '',
      features: [
        'Detalles del Evento',
        'Geocercas',
        'Invitados',
        'Lugares',
        'Reportes',
        'Rutas',
        'Seguimiento',
        'Recorridos',
        'Detalles del Vehículo'
      ]
    }
  },
  components: {
    'event-template-faq': EventTemplateFAQ,
    'geofences-faq': GeofencesFAQ,
    'guests-faq': GuestsFAQ,
    'places-faq': PlacesFAQ,
    'reports-faq': ReportsFAQ,
    'routes-faq': RoutesFAQ,
    'tracking-faq': TrackingFAQ,
    'travels-faq': TravelsFAQ,
    'vehicle-template-faq': VehicleTemplateFAQ
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Help.vue